import React from 'react';
import { InputRangeDate } from '@/components/form';
import { useFilters } from '@/hooks';
import { useRouter } from 'next/router';
import { useForm } from 'react-hook-form';
import { ButtonContentFilter } from '../../lawyerapp/client-directory/filters';
import { Typography } from '@/components/common';
import clsx from 'clsx';

interface Props {
	title: string;
	classNameField?: string;
	classNameTrigger?: string;
	restrictToPast?: boolean;
	disabled?: boolean;
	name?: string;
	dateFromLabel?: string;
	dateToLabel?: string;
}

export const DateRangeFilter: React.FC<Props> = ({
	title,
	classNameField,
	classNameTrigger,
	restrictToPast,
	disabled,
	name,
	dateFromLabel,
	dateToLabel,
}) => {
	const router = useRouter();
	const fromKey = dateFromLabel || 'dateFrom';
	const toKey = dateToLabel || 'dateTo';
	const dateFrom = router.query[fromKey];
	const dateTo = router.query[toKey];
	const { setParamSeveralFilters, hasFilter } = useFilters();
	const { register } = useForm();

	const handleSelectFilters = (
		_: string,
		value?: { from: string; to: string }
	): void => {
		setParamSeveralFilters([
			{
				label: dateFromLabel || 'dateFrom',
				value: value?.from,
			},
			{
				label: dateToLabel || 'dateTo',
				value: value?.to,
			},
		]);
	};

	return (
		<div className={clsx('flex items-center gap-2 min-h-8', classNameField)}>
			<Typography
				type="regular-12"
				className="text-opacity-black whitespace-nowrap"
			>
				{title}
			</Typography>
			<InputRangeDate
				restrictToPast={restrictToPast}
				buttonCustom
				name={name || 'date'}
				isFormatted={false}
				register={register}
				dateTo={dateTo as string}
				dateFrom={dateFrom as string}
				classNameTrigger={classNameTrigger}
				setValueInput={handleSelectFilters}
				buttonContent={
					<ButtonContentFilter
						active={hasFilter(dateFromLabel || 'dateFrom')}
					/>
				}
				disabled={disabled}
			/>
		</div>
	);
};
